<template>
  <div class="shoppe">
    <el-tabs v-model="activeName" type="card">
      <el-tab-pane label="基础信息" name="first"></el-tab-pane>
      <el-tab-pane label="对公账户信息" name="second"></el-tab-pane>
    </el-tabs>

    <el-form v-show="activeName === 'first'" ref="form" :model="form" label-width="150px">
      <el-form-item prop="stockLocationId" label="专柜名称" :rules="[{ required: true, message: '请选择专柜名称' }]">
        <el-select v-model="form.stockLocationId" filterable @change="(val) => getVendorName(val)">
          <el-option v-for="item in stockLocationList" :key="item.stockLocationId" :value="item.stockLocationId" :label="item.stockLocation"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="关联店铺别名">
        <el-input v-model="form.vendorNameAlias" disabled></el-input>
      </el-form-item>
      <el-form-item label="关联店铺">
        <el-input v-model="form.vendorName" disabled></el-input>
      </el-form-item>
      <el-form-item prop="taxRefundCompany" label="是否使用退税公司" :rules="[{ required: true, message: '请选择是否使用退税公司' }]">
        <el-radio v-model="form.taxRefundCompany" :label="0">否</el-radio>
        <el-radio v-model="form.taxRefundCompany" :label="1">是</el-radio>
      </el-form-item>
      <el-form-item v-if="form.taxRefundCompany == 0" prop="taxRefundRatio" label="退税比例" :rules="[{ required: true, message: '请输入退税比例' }, { validator: valiTaxRefundRatio, trigger: 'blur' }]">
        <el-input v-model="form.taxRefundRatio" :maxlength="6"></el-input>
      </el-form-item>
      <el-form-item v-if="form.taxRefundCompany == 1" prop="merchantTaxRefundCompanyId" label="退税公司" :rules="[{ required: true, message: '请选择退税公司' }]">
        <el-select v-model="form.merchantTaxRefundCompanyId" filterable>
          <el-option v-for="item in taxRefundCompanyList" :key="item.merchantTaxRefundCompanyId" :value="item.merchantTaxRefundCompanyId" :label="item.taxRefundCompanyName"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="payCurrencyUnit" label="结算货币单位" :rules="[{ required: true, message: '请选择结算货币单位' }]">
        <el-select v-model="form.payCurrencyUnit">
          <el-option v-for="item in unitList" :key="item.productExchangeRateId" :label="item.fromCountry" :value="item.fromCountry"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item prop="commissionRatio" label="买手佣金比例" :rules="[{ validator: valiRatio, trigger: 'blur' }]">
        <el-input v-model="form.commissionRatio" :maxlength="6" @input="changeNotRequired">
          <i slot="suffix" class="el-input__icon">%</i>
        </el-input>
      </el-form-item>
      <el-form-item prop="rebateRatio" label="返点/积分折现比例" :rules="[{ validator: valiRatio, trigger: 'blur' }]">
        <el-input v-model="form.rebateRatio" :maxlength="6" @input="changeNotRequired">
          <i slot="suffix" class="el-input__icon">%</i>
        </el-input>
      </el-form-item>
      <el-form-item prop="discountRatio" label="折扣" :rules="[{ validator: valiRatio, trigger: 'blur' }]">
        <el-input v-model="form.discountRatio" :maxlength="6" @input="changeNotRequired">
          <i slot="suffix" class="el-input__icon">%</i>
        </el-input>
      </el-form-item>
      <el-form-item prop="rechargeRemindAmount" label="充值提醒金额" :rules="[{ validator: valiRechargeRemindAmount, trigger: 'blur' }]">
        <el-input v-model="form.rechargeRemindAmount" :maxlength="20" @input="changeNotRequired"></el-input>
      </el-form-item>
      <el-form-item prop="bankInfo" label="个人银行卡账户信息">
        <el-input type="textarea" :rows="3" v-model="form.bankInfo" :maxlength="1000"></el-input>
      </el-form-item>
      <el-form-item prop="alipayInfo" label="支付宝账户信息">
        <el-input type="textarea" :rows="3" v-model="form.alipayInfo" :maxlength="1000"></el-input>
      </el-form-item>
      <el-form-item prop="wechatInfo" label="微信账户信息">
        <el-input type="textarea" :rows="3" v-model="form.wechatInfo" :maxlength="1000"></el-input>
      </el-form-item>
      <el-form-item class="mt20">
        <el-button type="primary" @click="submit">保存</el-button>
        <el-button @click="$router.back()">返回</el-button>
      </el-form-item>
    </el-form>

    <el-form v-show="activeName === 'second'" ref="bankInfoForm" :model="bankInfoForm" label-width="190px">
      <el-form-item prop="payeeName" label="收款方Name of Payee">
        <el-input v-model="bankInfoForm.payeeName" :maxlength="70"></el-input>
      </el-form-item>
      <h2 class="mb10">银行信息</h2>
      <el-form-item prop="remitBankName" label="银行名称Name of Bank">
        <el-input v-model="bankInfoForm.remitBankName" :maxlength="70"></el-input>
      </el-form-item>
      <el-form-item prop="remitBankAccount" label="银行账号Bank Account No.">
        <el-input v-model="bankInfoForm.remitBankAccount" :maxlength="70"></el-input>
      </el-form-item>
      <el-form-item prop="remitBankAddress" label="银行地址Bank Address">
        <el-input v-model="bankInfoForm.remitBankAddress" :maxlength="70"></el-input>
      </el-form-item>
      <el-form-item prop="remitIban" label="IBAN（仅欧盟地区填写）">
        <el-input v-model="bankInfoForm.remitIban" :maxlength="70"></el-input>
      </el-form-item>
      <el-form-item prop="remitSwiftCode" label="SWIFT Code">
        <el-input v-model="bankInfoForm.remitSwiftCode" :maxlength="70"></el-input>
      </el-form-item>
      <el-form-item class="mt20">
        <el-button type="primary" @click="submit">保存</el-button>
        <el-button @click="$router.back()">返回</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import {
  getMerchantStockLocationList,
  getMerchantVendorList,
  getMerchantTaxRefundCompanyList,
  createOrUpdateAccount,
  findAccountInfoById,
} from "../../api/merchants";
import {
  getUnitList,
} from '../buyershop/api';

export default {
  components: {
  },
  data() {
    return {
      activeName: 'first',
      stockLocationList: [],
      taxRefundCompanyList: [],
      unitList: [],
      form: {
        vendorName: null,
        merchantAccountId: null,
        stockLocationId: null,
        taxRefundCompany: 0,
        taxRefundRatio: 1,
        merchantTaxRefundCompanyId: null,
        payCurrencyUnit: null,
        commissionRatio: 0,
        rebateRatio: 0,
        discountRatio: 100,
        rechargeRemindAmount: null,
        bankInfo: null,
        alipayInfo: null,
        wechatInfo: null,
      },
      bankInfoForm: {
        payeeName: null,
        remitBankName: null,
        remitBankAccount: null,
        remitBankAddress: null,
        remitIban: null,
        remitSwiftCode: null,
      },
      tableData: [],
      inputStockLocationId: null,
    };
  },
  mounted() {
    getMerchantStockLocationList().then(res => {
      this.stockLocationList = res.data.data || [];
    })
    getMerchantTaxRefundCompanyList().then(res => {
      this.taxRefundCompanyList = res.data.data || [];
    })
    getUnitList().then(res => {
      this.unitList = res && res.data && res.data.data || [];
    })
    if (this.$route.params.id) {
      this.getDetail();
    }
  },
  methods: {
    getDetail() {
      findAccountInfoById({
        merchantAccountId: this.$route.params.id,
      }).then(res => {
        if (res.data && res.data.data) {
          this.form = res.data.data;
          this.bankInfoForm = {
            payeeName: res.data.data.payeeName,
            remitBankName: res.data.data.remitBankName,
            remitBankAccount: res.data.data.remitBankAccount,
            remitBankAddress: res.data.data.remitBankAddress,
            remitIban: res.data.data.remitIban,
            remitSwiftCode: res.data.data.remitIban,
          }
          this.getVendorName(this.form.stockLocationId);
        }
      })
    },
    getVendorName(stockLocationId) {
      getMerchantVendorList({
        stockLocationId,
      }).then(res => {
        if (res.data && res.data.data) {
          this.form.vendorName = res.data.data.vendorName;
          this.form.vendorNameAlias = res.data.data.vendorNameAlias;
        }
      })
    },
    submit() {
      if (this.repeatSave) {
        return;
      }
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$refs.bankInfoForm.validate((valid2) => {
            if (valid2) {
              this.$confirm('请仔细核对以上配置信息准确', '确认', {
                confirmButtonText: '确认创建',
                cancelButtonText: '再看看',
                type: 'warning'
              }).then(() => {
                if (this.repeatSave) {
                  return;
                }
                this.repeatSave = true;
                createOrUpdateAccount({
                  ...this.form,
                  ...this.bankInfoForm,
                }).then(res => {
                  this.repeatSave = false;
                  if (res.data.success) {
                    this.$message.success('成功');
                    this.$router.back();
                  } else {
                    this.$message.error(res.data.data || res.data.message);
                  }
                }).catch(() => {
                  this.repeatSave = false;
                })
              }).catch(() => {});
            } else {
              this.$message.error('请检查对公账户信息');
              return false;
            }
          })
        } else {
          this.$message.error('请检查基础信息');
          return false;
        }
      });
    },
    changeNotRequired() {
      if (this.form.commissionRatio === '') {
        this.form.commissionRatio = null;
        this.$refs.form.clearValidate('commissionRatio');
      }
      if (this.form.rebateRatio === '') {
        this.form.rebateRatio = null;
        this.$refs.form.clearValidate('rebateRatio');
      }
      if (this.form.discountRatio === '') {
        this.form.discountRatio = null;
        this.$refs.form.clearValidate('discountRatio');
      }
      if (this.form.rechargeRemindAmount === '') {
        this.form.rechargeRemindAmount = null;
        this.$refs.form.clearValidate('rechargeRemindAmount');
      }
    },
    valiTaxRefundRatio(rule, value, callback) {
      if (!/^\d+(\.\d{1,2})?$/.test(value)) {
        callback(new Error('仅允许输入大于0小于100的数字，请修改'));
      } else if (Number(value) <= 0 || Number(value) > 100) {
        callback(new Error('仅允许输入大于0小于100的数字，请修改'));
      } else {
        callback();
      }
    },
    valiRatio(rule, value, callback) {
      if (value === '' || value === null) {
        callback();
      } else if (!/^\d+(\.\d{1,2})?$/.test(value)) {
        callback(new Error('仅允许输入大于等于0小于等于100的数字，请修改'));
      } else if (Number(value) < 0 || Number(value) > 100) {
        callback(new Error('仅允许输入大于等于0小于等于100的数字，请修改'));
      } else {
        callback();
      }
    },
    valiRechargeRemindAmount(rule, value, callback) {
      if (value === '' || value === null) {
        callback();
      } else if (!/^\d+(\.\d{1,2})?$/.test(value)) {
        callback(new Error('仅允许输入大于0的数字，请修改'));
      } else if (Number(value) <= 0) {
        callback(new Error('仅允许输入大于0的数字，请修改'));
      } else {
        callback();
      }
    },
  },
};
</script>
<style lang="less" scoped>
.shoppe {
  max-width: 600px;
  padding: 20px;
}
.tr {
  margin-top: 10px;
  text-align: right;
}
.ml10 {
  margin-left: 10px;
}
.mt10 {
  margin-top: 10px;
}
.mt20 {
  margin-top: 20px;
}
.upload-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 10px;
  padding-bottom: 20px;
  color: #999;
  font-size: 12px;
  line-height: 1;
  // border: 1px dashed #DCDFE6;
  // background-color: #f8f8f8;
  // border-radius: 4px;

  .icon {
    color: #aaa;
    font-size: 50px;
  }
}
.mb10 {
  margin-bottom: 10px;
}
</style>
<style lang="less">
.upload-el {
  .el-upload--text {
    display: block;
  }
  .el-upload-dragger {
    width: auto;
    height: auto;
  }
  .el-icon-upload {
    margin: 0;
  }
}
</style>
